<template>
	<div>

		<!-- SINGLE PARTICIPANT -->
		<div class="m-b-0" v-if="hasSingleParticipant">
			<h3 class="h5">Participant:</h3>
			{{ participants[0].displayName }}
		</div>

		<!-- MULTIPLE PARTICIPANTS -->
		<div v-else>
			<div class="form-group m-b-0" v-if="hasSpotSelection">
				<h3 class="h5">
					Participant<span v-show="selectedParticipants.length > 1">s</span><a id="participantSelector" v-show="hasRules" class="text-gray-3" href="#specialRequirements" aria-label="View special requirements">*</a>:
				</h3>
				<div class="m-b-0" v-for="participant in selectedParticipants" :key="participant.memberId">
					{{ participant.firstName }} has been assigned spot {{ participant.spot }}. <button class="btn btn-link btn-link-simple align-baseline" v-if="availableSpots && !participant.isEditing" @click="editParticipant(participant)">Edit Spot</button><strong v-if="participant.isEditing">Select a different spot below.</strong>
				</div>
				<div v-if="unavailableParticipants.length > 0" class="m-t-1">
					<strong>
						Member<span v-show="unavailableParticipants.length > 1">s</span> not added:
					</strong>
					<div class="m-b-0" v-for="participant in unavailableParticipants" :key="participant.memberId">
						{{ participant.firstName }}*
					</div>
					*You may add members to the waitlist after completion
				</div>
			</div>
			<div v-else>
				<h3 class="h5">Participant<span v-show="participants.length > 1">s</span>:</h3>
				<p class="m-b-0" v-for="participant in selectedParticipants" :key="participant.memberId">
					{{ participant.firstName }}
				</p>
				<div v-if="unavailableParticipants.length > 0" class="m-t-1">
					<strong>
						Member<span v-show="unavailableParticipants.length > 1">s</span> not added:
					</strong>
					<p class="m-b-0" v-for="participant in unavailableParticipants" :key="participant.memberId">
						{{ participant.firstName }}*
					</p>
					*You may add members to the waitlist after completion
				</div>
			</div>
		</div>

	</div>
</template>

<script>
import Vue, { defineComponent } from 'vue';

export default defineComponent({
	name: 'ParticipantSub',
	props: {
		hasSingleParticipant: {
			default: false,
			type: Boolean
		},
		hasSpotSelection: {
			default: false,
			type: Boolean
		},
		availableSpots: {
			default: false,
			type: Boolean
		},
		participants: {
			default: () => [],
			type: Array
		},
		hasRules: {
			default: false,
			type: Boolean
		}
	},
	data() {
		return {
			selectedParticipants: [],
			unavailableParticipants: []
		};
	},
	watch: {
		participants: function() {
			this.completeMounting();
		}
	},
	mounted() {
		this.completeMounting();
	},
	methods: {
		completeMounting() {
			if (this.hasSingleParticipant) {
				this.selectedParticipants = this.participants;
			} else {
				this.selectedParticipants = this.participants.filter(p => p.status !== 'notRegistered');
				this.unavailableParticipants = this.participants.filter(p => p.status === 'notRegistered');
				this.selectedParticipants.forEach(p => Vue.set(p, 'isEditing', false));
				if (this.selectedParticipants.length === 1 && this.availableSpots) {
					this.$nextTick(() => { // Allow PickASpotSub to mount before firing 'edit-participant-spot'
						this.editParticipant(this.selectedParticipants[0]);
					});
				}
			}
		},
		editParticipant(participant) {
			this.selectedParticipants.forEach(p => { p.isEditing = false; });
			participant.isEditing = true;
			this.$parent.$emit('edit-participant-spot', participant);
		},
		setSelectedData(participants) {
			this.selectedParticipants = participants.filter(p => p.status !== 'notRegistered');
			if (this.selectedParticipants.length === 1) {
				this.editParticipant(this.selectedParticipants[0]);
			} else {
				this.selectedParticipants.forEach(p => { p.isEditing = false; });
			}
		},
		getSelectedData() {
			return this.selectedParticipants;
		}
	}
});
</script>
